import { LuxedoRPC } from "luxedo-rpc"

type ProcessingData = {
	progress: number
	status: "success" | "fail" | "processing"
}

class MediaProgressHandler {
	progress: { [index: number]: ProcessingData } = $state({})

	constructor() {
		this.listenToProgress()
	}

	private handleUploadProgress = (mediaId: number, progress: number) => {
		this.progress[mediaId] = {
			progress: progress,
			status: "processing",
		}
	}

	private handleUploadFail = (mediaId: number) => {
		const existingProgress = this.progress[mediaId]?.progress ?? 0
		this.progress[mediaId] = {
			progress: existingProgress,
			status: "fail",
		}
	}

	private handleUploadSuccess = (mediaId: number) => {
		this.progress[mediaId] = {
			status: "success",
			progress: 1,
		}
	}

	public setTemporaryProgress(mediaId: number, progress: number) {
		this.progress[mediaId] = {
			progress,
			status: "processing",
		}
	}

	listenToProgress() {
		LuxedoRPC.bindEndpoint("mupload_set_progress", this.handleUploadProgress)
		LuxedoRPC.bindEndpoint("mupload_process_complete", this.handleUploadSuccess)
		LuxedoRPC.bindEndpoint("mupload_process_fail", this.handleUploadFail)
	}
}

export const mediaProgressHandler = new MediaProgressHandler()
